import { ITextFieldMask } from '../../HookFormFields/types';

const nonCardIdChars = /[^0-9a-zA-Z]/g;
const cardIdGroupBoundary = /([0-9a-zA-Z])(?=([0-9a-zA-Z]{4})+$)/g;

export const cardIdentifierMask: ITextFieldMask = {
  // match scanner output by keeping card ids uppercase
  format: (value) => {
    const rawValue = value.replaceAll(nonCardIdChars, '').toUpperCase();

    return rawValue.replaceAll(cardIdGroupBoundary, '$1 ').toUpperCase();
  },
  parse: (value) => value.replaceAll(nonCardIdChars, '').toUpperCase(),
};
